export const PORTRAIT_BOTTOM_CONTENT = [
  "nonessential_lower_body", "scenery", "featured_product",
  "copy_or_branding", "collage_or_inset", "uncertain",
] as const;
export const PORTRAIT_ADMISSION_DECISIONS = [
  "eligible", "model_rejected", "invalid_response", "unavailable", "uncertain_head_evidence",
  "bottom_head_risk", "boundary_blocked", "edge_rejected",
] as const;
export const PORTRAIT_BOUNDARY_OBJECT_KINDS = [
  "scenery", "nonessential_lower_body", "featured_product", "copy_or_branding",
  "head_or_face", "upper_body_or_hands", "uncertain",
] as const;
export interface PortraitBoundaryObject {
  kind: (typeof PORTRAIT_BOUNDARY_OBJECT_KINDS)[number];
  box: [number, number, number, number];
  observation: string;
}
export interface ProductAppearanceCheck {
  decision:"clear"|"blocked"|"unavailable"|"not_applicable";
  anchorCount:number;
  matchedPixels:number;
  largestPatch:number;
  supportFraction?:number;
}
export interface SafeZonePortraitAdmission {
  version: 2;
  decision: (typeof PORTRAIT_ADMISSION_DECISIONS)[number];
  modelBottomEligible: boolean | null;
  bottomContent: (typeof PORTRAIT_BOTTOM_CONTENT)[number] | null;
  featuredProductContained: boolean | null;
  essentialContentAtEdge: boolean | null;
  bottomObservation: string;
  layout?: "single_photo" | "collage_or_inset" | "uncertain";
  edge?: {
    decision: "verified" | "rejected" | "invalid_response" | "unavailable";
    content: string | null;
    observation: string;
    version?: 3 | 4;
    reason?: string;
    objects?: PortraitBoundaryObject[];
    tiles?: string[];
    appearance?: ProductAppearanceCheck;
    personPresent?: boolean;
  };
}

export interface SafeZonePortraitOutcome {
  topRisk: boolean;
  bottomRisk: boolean;
  bottomEligible: boolean;
  top: "protected" | "background" | "fallback";
  bottom: "continued" | "baseline" | "fallback";
  cause: "delivered" | "guard" | "ineligible" | "qa" | "provider";
  observation: string;
  // Optional for historical outcomes. Never backfill a decision we did not record.
  admission?: SafeZonePortraitAdmission;
  topPolicy?: "structure_free_background";
  output?: {
    content: string | null; observation: string; safeBottom: boolean;
    tiles?: string[]; appearance?: ProductAppearanceCheck; reason?: string;
  };
}
